module.exports = __webpack_public_path__ + "static/sai_logo-1daef3f5e2fb25e0eae2ddcf647df7a1.png";